// extracted by mini-css-extract-plugin
module.exports = {"label":"_1GUiN","fileType":"_2AerH"};